import { DocumentFile } from 'src/shared/models/documentFile';

// Över denna totala bilagestorlek skickas bilagorna som nedladdningslänkar (AttachmentsAsLinks)
// istället för att bifogas i mejlet. Matchar backendens ursprungliga 10 MB-gräns.
export const ATTACHMENTS_AS_LINKS_THRESHOLD_BYTES = 10 * 1024 * 1024;

// Hårt tak för total bilagestorlek. Hela requesten (bilagor + mejltext + multipart-overhead) måste rymmas
// i serverns request-body-gräns (~30 MB) – vi lägger oss strax under för marginal och blockerar i UI ovanför.
export const ATTACHMENTS_MAX_TOTAL_BYTES = 28 * 1024 * 1024;

// Summerar storleken på nyuppladdade filer (File.size).
// OBS: RHF-fältet 'files' är en tom sträng ('') tills något laddats upp (ControlledFileDropZone defaultValue),
// så vi måste vakta mot icke-arrayer innan reduce.
export const sumFileSizes = (files?: unknown): number =>
  (Array.isArray(files) ? (files as File[]) : []).reduce((sum, file) => sum + (file?.size ?? 0), 0);

// Summerar storleken på redan sparade bilagor (documentFiles). fileSize lagras som sträng.
export const sumDocumentFileSizes = (documentFiles?: DocumentFile[] | null): number =>
  (documentFiles ?? []).reduce((sum, doc) => sum + (Number(doc?.fileSize) || 0), 0);

// Total bilagestorlek: nya filer + ev. redan sparade bilagor.
export const totalAttachmentBytes = (files?: unknown, documentFiles?: DocumentFile[] | null): number =>
  sumFileSizes(files) + sumDocumentFileSizes(documentFiles);

// True när den totala bilagestorleken överstiger tröskeln och bilagorna ska skickas som länkar.
export const shouldSendAttachmentsAsLinks = (files?: unknown, documentFiles?: DocumentFile[] | null): boolean =>
  totalAttachmentBytes(files, documentFiles) > ATTACHMENTS_AS_LINKS_THRESHOLD_BYTES;

// True när den totala bilagestorleken överstiger det hårda taket och utskicket inte får skickas.
export const attachmentsExceedMax = (files?: unknown, documentFiles?: DocumentFile[] | null): boolean =>
  totalAttachmentBytes(files, documentFiles) > ATTACHMENTS_MAX_TOTAL_BYTES;
